import React from 'react';
import { Grid } from '@mui/material';
import { Checkboxes, DatePicker, TextField } from 'mui-rff';
import { styled } from '@mui/material/styles';
import DateFnsUtils from '@date-io/date-fns';
//
import { DEFAULT_DATE_FORMAT } from '../../../../constants/reports';

const FlexGridItem = styled(Grid)(() => ({
  display: 'flex',
  alignItems: 'flex-end',
}));

const datePickerFieldProps = {
  format: (date) =>
    date ? (typeof date === 'string' ? new Date(date) : date) : null,
};
const textFieldProps = {
  parse: (value) => value,
};
export default function NotificationConfigDetails({
  flagName,
  flagLabel,
  secondaryFlagName,
  secondaryFlagLabel,
  textName,
  textLabel = 'Text',
  dateName,
  dateLabel = 'Date',
  startDateName,
  startDateLabel = 'Start Date',
  disabled,
  flagValue,
  textRows = 0,
  className = '',
  startDateDisabledOverride,
}) {
  return (
    <FlexGridItem size={{ xs: 12 }} className={className} container spacing={2}>
      <FlexGridItem size={{ xs: secondaryFlagName ? 6 : 12 }}>
        <Checkboxes
          name={flagName}
          disabled={disabled}
          formControlProps={{ margin: 'none', disabled }}
          data={{ label: flagLabel, value: false }}
        />
      </FlexGridItem>
      {secondaryFlagName ? (
        <FlexGridItem size={{ xs: 6 }}>
          <Checkboxes
            name={secondaryFlagName}
            disabled={disabled || !flagValue}
            formControlProps={{ margin: 'none', disabled }}
            data={{ label: secondaryFlagLabel, value: false }}
          />
        </FlexGridItem>
      ) : null}
      {startDateName ? (
        <FlexGridItem size={{ xs: 6 }}>
          <DatePicker
            name={startDateName}
            margin='none'
            label={startDateLabel}
            dateFunsUtils={DateFnsUtils}
            format={DEFAULT_DATE_FORMAT}
            fieldProps={datePickerFieldProps}
            disabled={
              (typeof startDateDisabledOverride === 'boolean'
                ? startDateDisabledOverride
                : !flagValue) || disabled
            }
          />
        </FlexGridItem>
      ) : null}

      <FlexGridItem size={{ xs: startDateName ? 6 : 12 }}>
        <DatePicker
          name={dateName}
          margin='none'
          label={dateLabel}
          dateFunsUtils={DateFnsUtils}
          format={DEFAULT_DATE_FORMAT}
          fieldProps={datePickerFieldProps}
          disabled={!flagValue || disabled}
        />
      </FlexGridItem>
      <FlexGridItem size={{ xs: 12 }}>
        <TextField
          name={textName}
          label={textLabel}
          fullWidth
          disabled={!flagValue || disabled}
          fieldProps={textFieldProps}
          multiline={!!textRows}
          rows={textRows}
        />
      </FlexGridItem>
    </FlexGridItem>
  );
}

export { NotificationConfigDetails };
